import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { importCustomTable } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

type TError = ErrorModal;

type TResult = string;

type TVariables = {
  account: number;
  file: File;
  lookupId: string;
  isForced?: boolean;
};

type TSnapshot = unknown;

function useUploadCustomTable(
  setProgress?: (progress: number) => void,
): UseMutationResult<TResult, TError, TVariables, TSnapshot> {
  function updateProgress(evt: any) {
    if (evt.lengthComputable) {
      // evt.loaded the bytes the browser received
      // evt.total the total bytes set by the header
      // jQuery UI progress bar to show the progress on screen
      const percentComplete = (evt.loaded / evt.total) * 100;
      setProgress && setProgress(percentComplete);
    }
  }
  const queryClient = useQueryClient();
  return useMutation(
    async ({ account, lookupId, file, isForced }: TVariables) => {
      try {
        await new Promise((res, rej) => {
          const formData: FormData = new FormData();
          formData.append('file', file);
          const xhr = new XMLHttpRequest();
          xhr.open(
            'PUT',
            `${importCustomTable(account, lookupId)}${
              isForced ? '?force=true' : ''
            }`,
          );
          xhr.setRequestHeader('Authorization', getTokenWithType());
          xhr.onreadystatechange = function (aEvt: any) {
            if (xhr.readyState === 4) {
              if (
                aEvt.currentTarget.status >= 200 &&
                aEvt.currentTarget.status <= 210
              ) {
                res(aEvt.currentTarget.response);
              } else {
                rej(JSON.parse(aEvt.currentTarget.response));
              }
            }
          };
          xhr.onprogress = updateProgress;
          xhr.upload.addEventListener('progress', updateProgress);
          xhr.onerror = e => rej(e);
          xhr.send(formData);
        });
      } catch (e) {
        console.log('EEEEEE', e);
        throw e;
      }
      queryClient.invalidateQueries(['get_custom_table'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['custom_records'], {
        refetchInactive: true,
      });
      return `Success`;
    },
  );
}

export { useUploadCustomTable };
